import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['csvType']

  declare readonly csvTypeTarget: HTMLInputElement

  setCsvType(event: Event & { params: { csvType: string } }): void {
    if (!event.params.csvType) return

    this.csvTypeTarget.value = event.params.csvType
  }
}
